import React from 'react';
import TransportForm from '../TransportForm';

const TransportFormPlaceholder: React.FC<any> = ({ initialData = {}, onSave, onCancel }) => {
  return <TransportForm value={initialData} onSave={onSave} onCancel={onCancel} compact />;
};

export default TransportFormPlaceholder;
